export const getCountyStateRequired = (country?: GQL.ICountry) => {
  return country && country.states && country.states.length > 0;
};


// WEBPACK FOOTER //
// ./src/helpers/country/getCountyStateRequired.ts